/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Milestone_ChangedInputs */

const en_toast_milestone_changed = /** @type {(inputs: Toast_Milestone_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestone changed`)
};

const de_toast_milestone_changed = /** @type {(inputs: Toast_Milestone_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilenstein geändert`)
};

/**
* | output |
* | --- |
* | "Milestone changed" |
*
* @param {Toast_Milestone_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_milestone_changed = /** @type {((inputs?: Toast_Milestone_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Milestone_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_milestone_changed(inputs)
	return en_toast_milestone_changed(inputs)
});